import loadable from '@loadable/component';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const ViewGradProgramPageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ViewGradProgramPage" */
      './ViewGradProgramPage.dynamic'
    ),
  { fallback: <LoadableLoadingSection /> },
);
